module.exports = __webpack_public_path__ + "valentinaperoni.jpg?2a2d9e228521c5a2a98fc2825615d1c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/valentinaperoni.jpg
// module id = 159
// module chunks = 0